import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

export default function BannerCarousel({ banners = [] }) {
  const [index, setIndex] = useState(0);
  const count = banners.length;

  const go = useCallback((dir) => setIndex((i) => (i + dir + count) % count), [count]);

  useEffect(() => {
    if (count <= 1) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % count), 6000);
    return () => clearInterval(t);
  }, [count]);

  if (!count) return null;
  const b = banners[index];

  return (
    <div className="carousel">
      <AnimatePresence mode="popLayout">
        <motion.div
          key={b._id || index}
          className="carousel__slide"
          initial={{ opacity: 0, scale: 1.06 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <img className="carousel__img" src={b.image} alt={b.title} />
          <div className="carousel__scrim" />
        </motion.div>
      </AnimatePresence>

      <div className="carousel__content">
        <motion.div
          key={`c-${index}`}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          {b.title && <h1>{b.title}</h1>}
          {b.subtitle && <p>{b.subtitle}</p>}
          {b.ctaText && (
            <Link to={b.ctaLink || '/products'} className="btn btn-primary">{b.ctaText}</Link>
          )}
        </motion.div>
      </div>

      {count > 1 && (
        <>
          <button className="carousel__arrow left" onClick={() => go(-1)} aria-label="Previous"><FiChevronLeft /></button>
          <button className="carousel__arrow right" onClick={() => go(1)} aria-label="Next"><FiChevronRight /></button>
          <div className="carousel__dots">
            {banners.map((_, i) => (
              <button
                key={i}
                className={`carousel__dot ${i === index ? 'active' : ''}`}
                onClick={() => setIndex(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
